import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPIReference,
  JSONAPISingleRelationship
} from "./Helpers";
import {Contact} from "./Contact";
import {Address} from "./Address";

interface HealthProvider extends DeserializedRecord<"health_provider"> {
  /**
   * A health provider may be linked to an identity, that provides the name, address and contact data
   */
  identity?: JSONAPIReference<"institution" | "person">;
  /**
   * When the health provider is linked with an identity. The name is taken from this identity
   */
  name: string;
  fieldCode: string;
  billingCode: string;
  immutable: boolean;
  kimMail: string;
  address?: Address;
  contact?: Contact;
}

interface HealthProviderData extends JSONAPIRecord {
  relationships: {
    address: JSONAPISingleRelationship;
    contact: JSONAPISingleRelationship;
    identity: JSONAPISingleRelationship;
  }
}


const deserializeHealthProvider: Deserializer<HealthProvider, HealthProviderData> = (data, included) => {
  const address = deserializeSingleRelationship<Address>(data.relationships.address, included);
  const contact = deserializeSingleRelationship<Contact>(data.relationships.contact, included);
  const identity = deserializeSingleRelationship<JSONAPIReference<"institution" | "person">>(data.relationships.identity, included);

  return {
    ...deserializeItem(data),
    address,
    contact,
    identity
  };
};


export {
  HealthProvider,
  deserializeHealthProvider
};

